// extracted by mini-css-extract-plugin
export default {"loaderContainer":"EditClientPage_loaderContainer__YvXio","errorBanner":"EditClientPage_errorBanner__O4WYO"};